import apiClient from "./api";
const CONTACTO_API_BASE_URL = "/contactos";
class ContactosService {
  getContactos() {
    return apiClient.get(CONTACTO_API_BASE_URL);
  }
  agregarContacto(contacto) {
    return apiClient.post(CONTACTO_API_BASE_URL, contacto);
  }
  updateContacto(contacto, contactoId) {
    return apiClient.put(CONTACTO_API_BASE_URL + "/" + contactoId, contacto);
  }
  deleteContacto(contactoId) {
    return apiClient.delete(CONTACTO_API_BASE_URL + "/" + contactoId);
  }
  async getContactosPorConvenio(convenioId) {
    try {
      const response = await apiClient.get(`${CONTACTO_API_BASE_URL}/convenio/${convenioId}`,);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new ContactosService();